<template>
    <div
        class="d-inline-flex align-items-center flex-nowrap ps-1"
        v-if="(emitId ?? '') !== ''"
    >
        <InputBool
            v-model="internalValue.UseExternalEMITID"
            class="me-2"
        />
        {{ emitId }}
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { RaceContestantDetailsExternalData } from '@/objects/RaceContestantDetailsExternalData';
import InputBool from '../Basic/InputBool.vue';
import type { ParticipantId } from '@/objects/generated';
import WellKnown from '@/objects/generated/static/WellKnown';

const props = defineProps<{
    /**
     * This is the category name from the source
     */
    value: ParticipantId[] | null;

    /**
     * The full row object
     */
    row: RaceContestantDetailsExternalData;
}>();

const internalValue = ref<RaceContestantDetailsExternalData>(props.row);

const emitId = computed(() => {
    if (!props.value) return '';

    return props.value.find((id) => id.ParticipantIDTypeID == WellKnown.IDTYPE_EMIT)?.Value ?? '';
});
</script>
